<template>
    <div class="main bg-g-white-transparent">

        <section id="brn-tours-list mt-5">
            <div class="container mt-5">
                <div class="row m-0">
                    <div v-for="event in filteredEvents" :key="event.id" class="col-lg-6">
                        <EventExtendedCard
                            :event="event"
                            :page-slug="getPageSlugByLayout('event-single')"
                            class="mb-4"/>
                    </div>
                </div>
            </div>
        </section>
        <section id="brn-tours" class="diagonal diagonal-top-only">
            <BorderDecoration class="top-left" style="left: -10%"/>
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 intro">
                        <h2 class="title" v-html="content['events-hero'].data.title"></h2>
                        <img :src="'storage/components/events-hero/' + content['events-hero'].data.image" alt="image">
                    </div>
                    <div class="col-lg-5 mt-5 pt-3">
                        <p v-html="content['events-hero'].data.text"></p>
                        <p class="h5 py-3">
                            <i class="bi bi-envelope-fill text-secondary me-3"></i>
                            <a :href="'mailto:' + content['events-hero'].data.email" class="text-dark text-decoration-underline">{{ content['events-hero'].data.email }}</a>
                        </p>
                        <p class="h5 py-3">
                            <i class="bi bi-telephone-fill text-secondary me-3"></i>
                            <a :href="'tel:' + content['events-hero'].data.phone" class="text-dark">{{ content['events-hero'].data.phone }}</a>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import BorderDecoration from "../components/elements/BorderDecoration";
import EventExtendedCard from "../components/cards/EventExtendedCard";
import PageLayoutContentMixin from "../../mixins/ContentMixin";
import SettingsMixin from "../../mixins/SettingsMixin";
import {mapActions, mapGetters} from "vuex";
export default {
    name: "Events",
    components: {EventExtendedCard, BorderDecoration},
    mixins: [PageLayoutContentMixin, SettingsMixin],
    data() {
        return {
            tags: []
        }
    },
    computed: {
        ...mapGetters('app', ['events']),

        filteredEvents() {
            return this.events;
        }
    },
    methods: {
        ...mapActions('app', ['fetchEvents'])
    },
    mounted() {
        this.fetchEvents();
    }
}
</script>

<style scoped>

</style>
